<div class="revenue-chart rounded-xl !p-5">
  <h2 class="revenue-chart-title text-xl font-semibold mb-4">{{ title | translate }}</h2>
  <p-chart type="line" [data]="chartData" [options]="chartOptions" height="280px"></p-chart>
  <div class="revenue-chart-legend flex justify-center items-center gap-6 !mt-5">
    <div class="flex items-center gap-2">
      <div class="revenue-chart-legend-icon" [innerHTML]="revenueIcon"></div>
      <span class="text-[#FCA13B] text-sm font-normal">{{ 'commonTable.smatchyRevenue' | translate }}</span>
    </div>
    <div class="flex items-center gap-2">
      <div class="revenue-chart-legend-icon" [innerHTML]="refundsIcon"></div>
      <span class="text-[#EF4444] text-sm font-normal">{{ 'commonTable.totalRefunds' | translate }}</span>
    </div>
  </div>
</div>
